export default {
  name: "AuditState",
  props: {
    state: Number
  }
};